import { i18n } from '@src/i18n-setup';
import { isNil } from 'lodash';
import ApplicationFeeEnum, { getFromApi } from '@enums/application-fee-enum';
import getOfferOngoingFeesData from '@utils/offer/get-offer-ongoing-fees-data';
import { providerTypeEnum } from '@enums/user-enum';
import getField, {
  getFieldString,
  getFieldCurrency,
  getFieldPercent,
  getFieldCategory,
  getFieldDecimal,
} from '@utils/fields/common';

/**
 * Handy object to be passed to the ld-offer component,
 * especifically to fill `details` field with additional offer details.
 *
 * @param {Object} The processed offer
 * @return {Promise} A promise with the offer and the details.
 */
export default function getOfferDetailsData(offer, enquiry) {
  if (isNil(offer) || isNil(enquiry)) {
    return null;
  }

  const organisation = [getOrganisation(offer)];

  /* @TEMP temporarily hide broker name on offers and use the default 'lender category' below */
  // if (offer.fsp.provider_type === providerTypeEnum.BROKER) {
  //   organisation.push(getBrokerName(offer));
  // }

  if (offer.fsp.provider_type === providerTypeEnum.BROKER) {
    organisation.push({
      label: i18n.t('dashboard.offer.details.lender_category'),
      value: getFieldCategory(offer.organisation),
    });
  }
  /* temporary replacement end */

  if (offer.fsp.provider_type !== providerTypeEnum.BROKER) {
    organisation.push({
      label: i18n.t('dashboard.offer.details.lender_category'),
      value: getFieldCategory(offer.organisation),
    });
  }

  return {
    organisation,
    features: [
      {
        label: i18n.t('dashboard.offer.details.product_name'),
        value: offer.product_name,
      },
      {
        label: i18n.t('dashboard.offer.details.repayment_type'),
        value: getFieldString(`dashboard.offer.details.repayment_type_option.${offer.repayment_type}`, offer.repayment_type),
      },
      getApplicationFees(offer),
      {
        label: i18n.t('dashboard.offer.details.cash_back'),
        value: getFieldCurrency(offer.cash_back),
      },
      {
        label: i18n.t('dashboard.offer.details.maximum_lvr'),
        value: getFieldPercent(offer.maximum_lvr),
      },
      {
        label: i18n.t('dashboard.offer.ongoing_fees'),
        ...getOfferOngoingFeesData(offer),
      },
      {
        label: i18n.t('dashboard.offer.details.generated'),
        value: getFieldString(`dashboard.offer.details.generated_${offer.generated}`, offer.generated),
        tooltip: {
          text: i18n.t('dashboard.offer.details.generated_tooltip'),
        },
      },
    ],
  };
}

function getApplicationFees(offer) {
  const data = {
    label: i18n.t('dashboard.offer.details.application_fees'),
    value: applicationFeeValue(offer),
  };

  if (parseFloat(offer.application_fee_value) !== 0 && offer.waived) {
    data.oldValue = data.value;
    data.value = applicationFeeValue(offer, '0');
    data.svg = 'price-tag';
  }

  return data;
}

function applicationFeeValue(offer, value = null) {
  value = value || offer.application_fee_value;

  if (getFromApi(offer.application_fee_type) === ApplicationFeeEnum.PERCENT) {
    return getFieldPercent(value);
  }

  if (getFromApi(offer.application_fee_type) === ApplicationFeeEnum.CURRENCY) {
    return getFieldCurrency(value);
  }

  return getFieldDecimal(value);
}

function getOrganisation(offer) {
  // temporarily disabled version
  // const name = offer.fsp.provider_type === providerTypeEnum.BROKER
  //   ? offer.fsp.organisation.name
  //   : offer.organisation.name;
  //
  // return {
  //   label: i18n.t('dashboard.offer.details.company_name'),
  //   value: getField(name),
  // };
  // temp end

  // temporary enabled version
  return {
    label: i18n.t('dashboard.offer.details.company_name'),
    value: getField(offer.organisation.name),
  };
}

// Needed once the temporary workaround is reverted
// function getBrokerName(offer) {
//   return {
//     label: i18n.t('dashboard.offer.details.broker_name'),
//     value: `${offer.fsp.user.first_name} ${offer.fsp.user.last_name}`,
//   };
// }
